import { useQuery } from "@tanstack/react-query";
import type {
  permissionsManagerAPIInterface,
  permissionsManagerFetchInterface
} from "@dealer-center/ddc-pages-permissions-manager-interface";

const queryKeyBase = "ddc-pages-permissions-manager";

export function usePermissionsManagerAPIInterface({
  name
}: permissionsManagerFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { name }],
    queryFn: () => getFunction(name?.trim() || ""),
    enabled: !!name && name.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  name: string
): Promise<permissionsManagerAPIInterface> => {
  const res = await fetch("/landing/nxlambda/permissionsManager/" + name);
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
